import app from 'flarum/forum/app';
import withAttr from 'flarum/common/utils/withAttr';
import icon from 'flarum/common/helpers/icon';
import Field from './Field';
import {OptionDefinition} from '../models/JsonTypes';

export default class Select extends Field {
    whiteListConfigProperties() {
        return super.whiteListConfigProperties().concat([
            'options',
        ]);
    }

    configure() {
        return [
            this.optionsRule(),
        ];
    }

    fill() {
        const options: OptionDefinition[] = this.getConfig('options', []);

        let values = this.getSubmission();

        const value = Array.isArray(values) && values.length ? values[0] : '';

        return m('.Select', [
            m('select.Select-input.FormControl', {
                id: this.uniqueFieldId(),
                onchange: withAttr('value', (value: string) => {
                    if (value) {
                        this.setSubmission([value]);
                    } else {
                        this.setSubmission([]);
                    }
                }),
                value,
                disabled: this.isFillDisabled(),
            }, [
                m('option', {
                    value: '',
                    hidden: !!this.getConfig('required'),
                }, app.translator.trans('kilowhat-formulaire.forum.select.choose')),
                options.map(option => m('option', {
                    value: option.key,
                }, option.title)),
            ]),
            icon('fas fa-sort', {className: 'Select-caret'}),
        ]);
    }

    display() {
        const options: OptionDefinition[] = this.getConfig('options', []);

        let values = this.getSubmission();

        if (Array.isArray(values) && values.length) {
            const option = options.find(option => option.key === values[0]);

            if (option) {
                return m('p', option.title);
            }
        }

        // Will display a custom answer or empty field
        return super.display();
    }
}
